import React from "react";
import ReactDOM from 'react-dom/client';
import Routes from "./routes/Index";
import Home from "./Home"
import 'bootstrap/dist/css/bootstrap.css';

//export default props => <>{Routes}</>;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);
